import { Tabs } from 'components/ideal-core-ui'
import { ProposalTemplates } from './ProposalTemplates'
import { EmailTemplates } from './EmailTemplates'
import { ChecklistTemplates } from './ChecklistTemplates'
import { ProposalHtmlTemplates } from './ProposalHtmlTemplates'
import { CompanyLogo } from './CompanyLogo'
import { useLocation } from 'react-router'
import qs from 'query-string'

const Templates = () => {
  const location = useLocation()
  const search = qs.parse(location.search)

  return (
    <Tabs
      activeTabKey={search?.secondaryTab || 'html'}
      withUpdateUrl
      isSecondaryTab
      tabs={[
        {
          key: 'html',
          label: 'Proposal Templates - HTML Editor',
          value: <ProposalHtmlTemplates />
        },
        {
          key: 'word',
          label: 'Proposal Templates - Word Editor',
          value: <ProposalTemplates />
        },
        {
          key: 'email',
          label: 'Email Templates',
          value: <EmailTemplates />
        },
        {
          key: 'checklist',
          label: 'Checklist Templates',
          value: <ChecklistTemplates />
        },
        {
          key: 'logo',
          label: 'Company Logo',
          value: <CompanyLogo />
        }
      ]}
    />
  )
}

export default Templates
